import { getNotificationColour, Notification, NotificationVariant } from "../../../common/components";
import React, { useContext, useEffect, useState } from "react";
import styled, { css } from "styled-components";
import { ActionType } from "../../../AppDataProvider/actions";
import { AppContext } from "../../../AppDataProvider/AppDataProvider";
import { applyOpacity } from "../../../common/styles/utils";
import { typography } from "../../../common/styles";
export type ToastProps = React.PropsWithChildren<{
  // Delay before the toast notification begins to fade away
  delay?: number;
  toastId: number;
  // Duration of the actual transition from opaque to transparent, in seconds
  transition?: number;
  variant: NotificationVariant;
}>;
const defaultDelay = 5;
const defaultTransition = 1;
const StyledNotification = styled(Notification)<Omit<ToastProps, "toastId"> & {
  isFadingOut: boolean;
}>`
  ${({
  isFadingOut,
  transition = defaultTransition
}) => isFadingOut ? css`
          opacity: 0;
          transition: ${transition}s all ease-in-out;
        ` : null}

  /*
   * Base colour pinned to a literal static hex (not theme.colours.dark) —
   * conventional static UI chrome, not part of the dark-theme-aware fix in
   * theme.ts's computeTheme.
   */
  background: ${applyOpacity("#1A1A1A", 0.8)};
  color: ${({
  theme,
  variant
}) => applyOpacity(getNotificationColour(theme, variant), 0.2, false)};
  ${typography.bodyBold}
`;
export function Toast({
  children,
  delay = defaultDelay,
  toastId,
  transition = defaultTransition,
  variant
}: ToastProps) {
  const {
    appDataDispatch
  } = useContext(AppContext);
  const [isTimeoutSuspended, setIsTimeoutSuspended] = useState(false);
  const [isFadingOut, setIsFadingOut] = useState(false);
  useEffect(() => {
    if (!isTimeoutSuspended) {
      const removeToastTimeout = setTimeout(() => {
        appDataDispatch({
          payload: {
            id: toastId
          },
          type: ActionType.REMOVE_TOAST
        });
      }, (delay + transition) * 1000);
      const fadeTimeout = setTimeout(() => {
        setIsFadingOut(true);
      }, delay * 1000);
      return () => {
        clearTimeout(fadeTimeout);
        clearTimeout(removeToastTimeout);
      };
    }
  }, [appDataDispatch, delay, isTimeoutSuspended, toastId, transition]);
  const onMouseEnter = () => {
    setIsTimeoutSuspended(true);
    setIsFadingOut(false);
  };
  const onMouseLeave = () => {
    setIsTimeoutSuspended(false);
  };
  const props = {
    isFadingOut,
    onMouseEnter,
    onMouseLeave,
    variant
  };
  return <StyledNotification {...props} data-sentry-element="StyledNotification" data-sentry-component="Toast" data-sentry-source-file="Toast.tsx">{children}</StyledNotification>;
}
export default Toast;